import shopApi from "../../api/shop";

const SEARCH_FILLER_WORDS = new Set([
  "a", "an", "and", "business", "company", "for", "i", "in", "license",
  "licence", "looking", "need", "of", "package", "packages", "setup", "the",
  "to", "visa", "visas", "want", "with",
]);

const getMeaningfulWords = (value) => value
  .toLowerCase()
  .replace(/[^a-z0-9\s-]/g, " ")
  .split(/\s+/)
  .filter((word) => word && !SEARCH_FILLER_WORDS.has(word) && !/^\d+$/.test(word));

export const buildSearchCandidates = (value) => {
  const original = value.trim().replace(/\s+/g, " ");
  const words = getMeaningfulWords(original);
  const phraseCandidates = [];

  for (let start = 0; start < words.length - 1; start += 1) {
    phraseCandidates.push(words.slice(start, start + 2).join(" "));
  }

  return [...new Set([
    original,
    words.join(" "),
    ...phraseCandidates,
    ...words.sort((a, b) => b.length - a.length),
  ].filter((item) => item.length >= 2))];
};

export const rankProducts = (items, searchValue) => {
  const normalizedQuery = searchValue.toLowerCase().replace(/[^a-z0-9\s-]/g, " ").replace(/\s+/g, " ").trim();
  const queryWords = getMeaningfulWords(normalizedQuery);

  const scoreProduct = (product) => {
    const title = (product.title || "").toLowerCase();
    const searchable = [product.title, product.sku, product.shortDescription, product.description]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
    const matchedWords = queryWords.filter((word) => searchable.includes(word));
    let score = matchedWords.length * 100;

    if (normalizedQuery && searchable.includes(normalizedQuery)) score += 1000;
    if (queryWords.length && matchedWords.length === queryWords.length) score += 500;
    queryWords.forEach((word, index) => {
      if (title.includes(word)) score += 35;
      if (title.startsWith(word)) score += 15;
      if (index > 0 && title.includes(`${queryWords[index - 1]} ${word}`)) score += 50;
    });

    return score;
  };

  return items
    .map((product, index) => ({ product, index, score: scoreProduct(product) }))
    .sort((a, b) => b.score - a.score || a.index - b.index)
    .map(({ product }) => product);
};

export const getSmartProductSuggestions = async ({ query, category, limit = 6 }) => {
  const candidates = buildSearchCandidates(query);

  for (const candidate of candidates) {
    const options = { search: candidate };
    if (category && category !== "all") options.category = category;
    const result = await shopApi.getSuggestions(options);
    const matches = Array.isArray(result) ? result : [];

    if (matches.length > 0) {
      return {
        products: rankProducts(matches, query).slice(0, limit),
        effectiveQuery: candidate,
      };
    }
  }

  return {
    products: [],
    effectiveQuery: candidates[candidates.length - 1] || query.trim(),
  };
};
